import { performRequest } from 'common/utils/performRequest';

export const GET_BOOKING_GUESTROOM_NAME_REQUEST =
  'GET_BOOKING_GUESTROOM_NAME_REQUEST';
export const GET_BOOKING_GUESTROOM_NAME_SUCCESS =
  'GET_BOOKING_GUESTROOM_NAME_SUCCESS';
export const GET_BOOKING_GUESTROOM_NAME_FAILURE =
  'GET_BOOKING_GUESTROOM_NAME_FAILURE';

export default function getBookingGuestRoomName({
  roomTypeId,
  roomNameId,
  roomViewId,
  index,
}) {
  return async dispatch => {
    dispatch({
      type: GET_BOOKING_GUESTROOM_NAME_REQUEST,
    });

    try {
      const { data } = await performRequest(
        'get',
        `/api/content/names/booking/rooms?roomTypeId=${roomTypeId}&roomNameId=${roomNameId}${
          roomViewId ? `&roomViewId=${roomViewId}` : ''
        }`,
        {}
      );

      dispatch({
        type: GET_BOOKING_GUESTROOM_NAME_SUCCESS,
        payload: {
          name: data,
          index,
          roomTypeId,
          roomViewId: roomViewId ?? '',
          roomNameId,
        },
      });
    } catch (error) {
      dispatch({
        type: GET_BOOKING_GUESTROOM_NAME_FAILURE,
        payload: error.response.data,
      });
    }
  };
}
